import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatChipOption, MatChipListbox, MatChipSelectionChange } from '@angular/material/chips';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CognitoUser } from 'app/core/auth-shim';
import { filter, find } from 'lodash-es'
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DataShareService } from '../../../services/data-share.service';
import { AccountMembership, AccountType, APIService, UpdateAccountMembershipAction, UpdateAccountMembershipInput, UpdateUserInput, User, UserStatus } from '../../API.service.custom';
import { AuthService } from '../auth.service';
import localforage from 'localforage';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-not-allowed',
    templateUrl: './not-allowed.component.html',
    styleUrls: ['./not-allowed.component.scss'],
    imports: [RouterLink, RouterLinkActive, MatChipListbox, MatChipOption, TitleCasePipe]
})
export class NotAllowedComponent implements OnInit, OnDestroy {
  daysRemainingInTrial: number = null
  private userId = null;
  private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();
  isLoading = true

  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();

  private userDetails_: BehaviorSubject<any> = new BehaviorSubject(undefined);
  public userDetails = this.userDetails_.asObservable();
  private activeAccountMemberships: AccountMembership[] = [];
  private registeredUser: User = null;

  membershipId = null;
  activeAccount: AccountMembership = null;
  availableMemberships: AccountMembership[] = [];

  accountMembershipUpdateInitiated: Boolean = false;
  accountsInNeedOfAcceptance: AccountMembership[] = [];
  private routeParamSubscription?: Subscription;


  constructor(
    private dataService: DataShareService,
    private api: APIService,
    private toastr: ToastrService,
    private titleService: Title,
    private logger: NGXLogger,
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Trial');
    this.routeParamSubscription = this.route.paramMap.subscribe(params => {
      this.membershipId = params.get('id');
      this.getUserDetailsAndId();
    });

  }

  ngOnDestroy(): void {
    this.routeParamSubscription?.unsubscribe();
  }

  public async getUserDetailsAndId() {
    this.busy_.next(true);
    this.errorMessage_.next('');
    try {
      const userDetails: CognitoUser = await this.auth.currentAuthenticatedUser();
      this.userId = userDetails.getSignInUserSession().getIdToken().payload.userId;
      if (this.userId) {
        this.getUserRegistrationDetail(this.userId);
      }
      this.userDetails_.next(userDetails);
    } catch (err) {
      this.errorMessage_.next(err.message || err);
    } finally {
      this.busy_.next(false);
    }
  }

  private getUserRegistrationDetail(userId: string) {
    this.api.GetUser(userId).then(async event => {
      this.logger.log('User Registration Detail Fetched : ', event);
      if (event) {
        this.registeredUser = event;
        this.dataService.setRegisteredUser(this.registeredUser)
        this.getuserAccountMemberships(event);
      }
    })
      .catch(e => {
        this.logger.log('error fetching user registration detail', e);
      });

  }

  private getuserAccountMemberships(user: User) {
    this.api.AccountsByUser(user.id).then(event => {
      this.logger.log('User Account Memberships Fetched : ', event);
      if (event && event.items && event.items.length > 0) {
        event.items.forEach(item => {
          item.user = user;
        });
        this.activeAccountMemberships = filter(event.items, function (o) {
          return (o.userAccountStatus == UserStatus.ACTIVE || o.userAccountStatus == UserStatus.APPROVED) && (o.account.accountType == AccountType.TEAM || o.account.accountType == AccountType.TEAM_TRIAL);
        });
        this.accountsInNeedOfAcceptance = filter(event.items, function (item) {
          return item.userAccountStatus == UserStatus.APPROVED;
        });
        console.log("activeAccountMemberships memberships are ", this.activeAccountMemberships);
        if (this.activeAccountMemberships.length > 0) {
          if (this.membershipId != null && this.membershipId != "") {
            this.activeAccount = find(this.activeAccountMemberships, { 'id': this.membershipId });
            //Check Again the not authorized status
            if (this.activeAccount.account.permissions && this.activeAccount.account.permissions.length > 0) {
              let permissions = JSON.parse(this.activeAccount.account.permissions[0]);
              let web_access_restriced_permission = permissions["disable-web-access"];
              if (!(web_access_restriced_permission && web_access_restriced_permission[this.activeAccount.authorizationLevel.toLowerCase()] == true)) {
                this.updateLastActiveAccountWeb();
              }
            }

            if (this.activeAccount && this.activeAccount.account && (this.activeAccount.account.accountType == AccountType.TEAM || (this.activeAccount.account.accountType == AccountType.TEAM_TRIAL && (this.activeAccount.account.trialAccountEndDate < (new Date()).toISOString())))) {
              var membershipAccountId = this.activeAccount.accountId;
              this.availableMemberships = filter(this.activeAccountMemberships, function (o) {
                return o.account.id != membershipAccountId && (!o.account.trialAccountEndDate || o.account.trialAccountEndDate > (new Date()).toISOString());
              });
              console.log("Available memberships are ", this.availableMemberships);
            }
            else {
              // this.updateLastActiveAccountWeb();
            }
          }
          else
            this.activeAccount = this.activeAccountMemberships[0];
        }
        this.isLoading = false;
        // this.getTrialDaysRemaining();
      }
    })
      .catch(e => {
        this.logger.log('error fetching user account memberships', e);
        this.isLoading = false;
      });
  }


  getTrialDaysRemaining() {
    if (this.activeAccount.account.accountType == AccountType.TEAM_TRIAL && this.activeAccount.account.trialAccountEndDate != null) {
      var currentDate = new Date()
      var trialExpiryDate = new Date(this.activeAccount.account.trialAccountEndDate)
      var difference = trialExpiryDate.getTime() - currentDate.getTime();
      this.daysRemainingInTrial = Math.ceil(difference / (1000 * 3600 * 24));
      if (this.daysRemainingInTrial > 0)
        this.router.navigate(['/home/dashboard']);
      this.isLoading = false;
    }
  }

  toggleSelection(change: MatChipSelectionChange) {
    if (!change.isUserInput) {
      return;
    }

      const chip = change.source;

    if (change.selected) {
      this.activeAccount = change.source.value;
      this.updateLastActiveAccountWeb();
    }
  }

  updateLastActiveAccountWeb() {
    localforage.setItem('lastActiveAccountSelectedInBrowser', this.activeAccount.accountId);
    let input = <UpdateUserInput>{};
    input.lastSelectedAccountWeb = this.activeAccount.accountId;
    input.id = this.userId;
    this.api.UpdateUser(input).then(event => {
      this.logger.log('Last Active Account Web Updated : ', event);
      this.dataService.setActiveAccount(null);
      this.router.navigate(['/']);
    })
      .catch(e => {
        this.logger.log('error updating last active account for user', e);
      });
  }

  extendFreeTrial() {
    this.toastr.error('Trial Period Can Not be Extended at this time. Please reach out to us.');
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        this.logger.log(e.errors[_i].message);
      }
    }
  }

}
